import IconGridBlock from './IconGridBlock';

export default IconGridBlock;
